import { render } from "./SkillLibraryPage.vue?vue&type=template&id=6e971980&scoped=true"
import script from "./SkillLibraryPage.vue?vue&type=script&lang=js"
export * from "./SkillLibraryPage.vue?vue&type=script&lang=js"

import "./SkillLibraryPage.vue?vue&type=style&index=0&id=6e971980&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e971980"]])

export default __exports__